import { type ObjectWithId } from '@/lib/types';

const sortById = (a: ObjectWithId, b: ObjectWithId): number => {
  return a.id - b.id;
};

export default sortById;
